import React from "react";

import styles from "./UseConditions.module.scss";

const UseConditions: React.FC = () => {
  return (
    <section className={styles.useConditions}>
      <div className="container">
        <h3>Условия применения</h3>
        <ul className={styles.body}>
          <div className={styles.left}>
            <li>Покупку по сертификату можно совершить за одно посещение.</li>
            <li>
              Если сумма покупки меньше суммы, указанной на сертификате, разница между номиналом и суммой покупки не возвращается.
            </li>
            <li>
              Если сумма покупки превышает номинал, указанный в сертификате, покупатель может доплатить разницу между этой суммой
              и номиналом сертификата.
            </li>
            <li>
              При осуществление покупки по подарочному сертификату скидка по дисконтным картам постоянных покупателей
              предоставляется в рамках действующей дисконтной программы.
            </li>
            <li>Покупка подарочного сертификата, не подразумевает под собой бронь товара.</li>
            <li>Подарочный сертификат не подлежит обмену на денежный эквивалент.</li>
          </div>
          <div className={styles.right}>
            <li>
              Подарочный сертификат действителен один год с момента покупки. После истечения срока действия сертификат считается
              не действительным. Деньги, внесённые в оплату сертификата, после истечения срока не возвращаются.
            </li>
            <li>При осуществлении покупки необходимо предъявить распечатанный сертификат или уникальный код сертификата.</li>
            <li>Подарочный сертификат может передаваться третьему лицу.</li>
            <li>Приобретая подарочный сертификат, покупатель соглашается с условиями его использования.</li>
            <li>
              Настоящие условия могут быть изменены в одностороннем порядке без предварительного уведомления Владельца подарочного
              сертификата. Информацию об изменениях можно получить в магазинах или на сайте tekstil-pro.site
            </li>
          </div>
        </ul>
        <div className={styles.buy}>
          <button>Купить подарочный сертификат</button>
        </div>
      </div>
    </section>
  );
};

export default UseConditions;
